import { ExternalLink, } from "lucide-react";
import type { ComponentProps, } from "react";
import type { ITooltip } from "react-tooltip";

import styled from "styled-components";
import { Tooltip, } from "../Tooltip";
import { getTheme, } from "@bracket/ui/themes";


export declare type ExternalLinkIconProps = {
	$color?: string;
	$scale?: string;
	tooltip?: string;
	position?: ITooltip["place"];
} & ComponentProps<"svg">;




/**
 * An external link icon component with hover effects and styling options
 * 
 * @param {ExternalLinkIconProps} props - The component props
 * @param {string} [props.$color] - Optional CSS color for the icon
 * @param {string} [props.$scale] - Optional CSS size value for the icon (e.g., "16px", "1rem")
 * @param {string} [props.tooltip] - Optional tooltip message to display on hover
 * @param {ITooltip["place"]} [props.position] - Optional position for the tooltip
 * @returns {JSX.Element} A styled external link icon with optional tooltip
 */
export const ExternalLinkIcon = ({ tooltip, position, ...props }: ExternalLinkIconProps) => {
	const icon = <StyledExternalLink {...props} />;
	if(tooltip) {
		return (
			<Tooltip message={tooltip} position={position}>
				{icon}
			</Tooltip>
		);
	}
	return icon;
};



const StyledExternalLink = styled(ExternalLink)<{ $color?: string; $scale?: string }>`
	cursor: pointer;
	opacity: 0.7;
	transition: all 0.2s;
	color: ${({ $color, }) => `${$color || getTheme().surface_on};`}
	${props => props.$scale && `width: ${props.$scale}; height: ${props.$scale};`}
	&:hover {
		opacity: 1;
		color: ${() => getTheme().primary};
	}
	&:focus {
		outline: none;
	}
`;
